import React from "react";
import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { CSS_MQ } from "../../../../../styles/breakpoints";
import { StoriesOverviewBigTeaser } from "../stories-overview-big-teaser";
import { StoriesOverviewSmallTeaser } from "../stories-overview-small-teaser";
import { ExpandedStoryTeaser } from "../../../../../layouts/stories/stories-overview-page/stories-overview-page-layout";

export const BigAndThreeSmallRectangularLayout: ReactTFC<{
  big: ExpandedStoryTeaser;
  smallTeasers: Array<ExpandedStoryTeaser>;
}> = props => {
  const [first, second, third] = props.smallTeasers;

  return (
    <div
      css={css`
        margin-bottom: 40px;
        &:last-child {
          margin-bottom: 0;
        }
        ${CSS_MQ.atLeastSm} {
          margin-bottom: 30px;
        }
        ${CSS_MQ.atLeastLg} {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
          grid-column-gap: 35px;
          margin-bottom: 45px;
        }
      `}
    >
      <StoriesOverviewBigTeaser teaser={props.big} shouldStretchText={!first} />

      {first && (
        <div
          css={css`
            margin-top: 40px;
            ${CSS_MQ.atLeastSm} {
              margin-top: 30px;
            }
            ${CSS_MQ.atLeastLg} {
              grid-area: 3 / 2 / span 3 / span 1;
              margin-top: 45px;
            }
          `}
        >
          <StoriesOverviewSmallTeaser teaser={first} />
        </div>
      )}

      {second && (
        <div
          css={css`
            margin-top: 40px;
            ${CSS_MQ.atLeastSm} {
              margin-top: 30px;
            }
            ${CSS_MQ.atLeastLg} {
              grid-area: 5 / 1 / span 3 / span 1;
              margin-top: 45px;
            }
          `}
        >
          <StoriesOverviewSmallTeaser teaser={second} portraitImage />
        </div>
      )}

      {third && (
        <div
          css={css`
            margin-top: 40px;
            ${CSS_MQ.atLeastSm} {
              margin-top: 30px;
            }
            ${CSS_MQ.atLeastLg} {
              grid-area: 6 / 2 / span 2 / span 1;
              margin-top: 45px;
            }
          `}
        >
          <StoriesOverviewSmallTeaser teaser={third} />
        </div>
      )}
    </div>
  );
};
